export default {
    netWork: "https://rtoken-api.stafi.io"
}